import axios from 'axios';
import { NEWS_API_URL } from 'constants/urls';
import { NewsItem } from 'shared/types/news';
import { ucFirst } from 'shared/helper/string';
/* eslint-disable no-unused-vars */

const state = {
    newsItem: null,
    newsMain: [],
    news: [],
};

const actions = {
    loadNews({ commit }, data) {
        const typeNews = data.context;
        const count = data.count;
        const params = {
            limit: count,
            withCredentials: true
        };

        const host = this.state.context.host;
        axios.get(host + NEWS_API_URL, { params })
          .then((result) => {
              function pushInNews(item, typeNews) {
                  commit(typeNews, item);
              }

              result.data.items.forEach(
                  (item) => {
                      pushInNews(item, typeNews);
                  },
              );
          })
          .catch((error) => { console.error(error) });
    },
    /**
     * @param commit
     * @param { PageContextForNews } context
     * @param { { num: Number, perPage: Number } } pager
     * @return { Promise<{total: Number}> }
     */
    fetchNews({ commit }, { context, pager }) {
        return axios
          .get(
            this.state.context.host + NEWS_API_URL,
            {
              params: {
                limit: pager.perPage,
                page_num: pager.num,
                withCredentials: true
              }
            }
          )
          .then((result) => {
            function pushInNews(item, typeNews) {
              commit(typeNews, item);
            }
            result.data.items.forEach(
              (item) => {
                pushInNews(item, context);
                return false;
              },
            );
            const cnt = this.getters[`news/${context}`] ? this.getters[`news/${context}`].length : 0
            return { total: result.data.total, count: cnt };
          })
          .catch((error) => { console.error(error); });
  },
  /**
   * @param commit
   * @param { PageContextForNews } context
   * @return void
   */
  clearNews( { commit }, { context } ) {
    commit(`clear${ ucFirst(String(context)) }`)
  },
};

const mutations = {
    newsItem(state, value) {
        state.newsItem = value;
    },
    newsMain(state, value) {
        state.newsMain.push(value);
    },
    clearNewsMain(state) {
        state.newsMain = []
    },
    news(state, value) {
        state.news.push(value);
    },
    clearNews(state) {
        state.news = []
    }
};

const getters = {
    newsItem({ newsItem }) {
        return newsItem;
    },
    news({ news }) {
        return news.map((newsItem) => new NewsItem(newsItem));
    },
    newsMain({ newsMain }) {
        return newsMain.map((newsItem) => new NewsItem(newsItem));
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/news.js